import type { ExternalSiteCheckRule } from "../../types";
import { GODOMALL_PAGE, SITE_TYPE } from "./const";

const isGodomallByHomePath = (pathname: string) => {
  const result = ["/", "/main/index.php"].some((path) => {
    return path === pathname;
  });
  return result;
};

const godomall: ExternalSiteCheckRule = {
  type: SITE_TYPE,

  checkPage({ url, target }) {
    if (target.value === "HOME" && isGodomallByHomePath(url.pathname)) {
      return true;
    }

    if (
      target.value === GODOMALL_PAGE.LOGIN.target &&
      url.pathname === GODOMALL_PAGE.LOGIN.url
    ) {
      return true;
    }

    if (
      target.value === GODOMALL_PAGE.SIGNUP_INTRO.target &&
      url.pathname === GODOMALL_PAGE.SIGNUP_INTRO.url
    ) {
      return true;
    }
    if (
      target.value === GODOMALL_PAGE.SIGNUP_AGREEMENT.target &&
      url.pathname === GODOMALL_PAGE.SIGNUP_AGREEMENT.url
    ) {
      return true;
    }

    if (
      target.value === GODOMALL_PAGE.SIGNUP_MAIN.target &&
      url.pathname === GODOMALL_PAGE.SIGNUP_MAIN.url
    ) {
      return true;
    }

    if (
      target.value === GODOMALL_PAGE.SIGNUP_COMPLETE.target &&
      url.pathname === GODOMALL_PAGE.SIGNUP_COMPLETE.url
    ) {
      return true;
    }

    if (
      target.value === GODOMALL_PAGE.MY_PAGE.target &&
      url.pathname === GODOMALL_PAGE.MY_PAGE.url
    ) {
      return true;
    }

    if (
      target.value === GODOMALL_PAGE.FIND_ID.target &&
      url.pathname === GODOMALL_PAGE.FIND_ID.url
    ) {
      return true;
    }

    if (
      target.value === GODOMALL_PAGE.FIND_PASSWORD.target &&
      url.pathname === GODOMALL_PAGE.FIND_PASSWORD.url
    ) {
      return true;
    }

    if (
      target.value === GODOMALL_PAGE.CART.target &&
      url.pathname === GODOMALL_PAGE.CART.url
    ) {
      return true;
    }

    if (
      target.value === GODOMALL_PAGE.POLICY.target &&
      url.pathname === GODOMALL_PAGE.POLICY.url
    ) {
      return true;
    }

    if (
      target.value === GODOMALL_PAGE.PRIVACY.target &&
      url.pathname === GODOMALL_PAGE.PRIVACY.url
    ) {
      return true;
    }

    if (
      target.value === GODOMALL_PAGE.CHECK_ORDER.target &&
      url.pathname === GODOMALL_PAGE.CHECK_ORDER.url
    ) {
      return true;
    }

    if (
      target.value === GODOMALL_PAGE.CANCEL_ORDER.target &&
      url.pathname === GODOMALL_PAGE.CANCEL_ORDER.url
    ) {
      return true;
    }

    if (
      target.value === GODOMALL_PAGE.REFUND_LIST.target &&
      url.pathname === GODOMALL_PAGE.REFUND_LIST.url
    ) {
      return true;
    }

    if (
      target.value === GODOMALL_PAGE.COUPON.target &&
      url.pathname === GODOMALL_PAGE.COUPON.url
    ) {
      return true;
    }

    if (
      target.value === GODOMALL_PAGE.MILEAGE.target &&
      url.pathname === GODOMALL_PAGE.MILEAGE.url
    ) {
      return true;
    }

    if (
      target.value === GODOMALL_PAGE.WISH_LIST.target &&
      url.pathname === GODOMALL_PAGE.WISH_LIST.url
    ) {
      return true;
    }

    if (
      target.value === GODOMALL_PAGE.DELIVERY_ADDR_LIST.target &&
      url.pathname === GODOMALL_PAGE.DELIVERY_ADDR_LIST.url
    ) {
      return true;
    }

    if (
      target.value === GODOMALL_PAGE.MY_PAGE_PASSWORD.target &&
      url.pathname === GODOMALL_PAGE.MY_PAGE_PASSWORD.url
    ) {
      return true;
    }

    if (
      target.value === GODOMALL_PAGE.MEMBER_MODIFY.target &&
      url.pathname === GODOMALL_PAGE.MEMBER_MODIFY.url
    ) {
      return true;
    }

    if (
      target.value === GODOMALL_PAGE.MY_PAGE_QA.target &&
      url.pathname === GODOMALL_PAGE.MY_PAGE_QA.url
    ) {
      return true;
    }
    return false;
  },
};

export default godomall;
